import createQueryDuck from '@/redux/query';

import serializer from '../serializer';
import { getQueryRoot } from '../utils';

export default createQueryDuck('store_bonus_history', {
  getRoot: getQueryRoot,
  serializer,
});
